import { sports } from './constants';

// null = "allow all" (anonymous user); empty Set = authenticated but no data (allow none)
let allowedSportIds = null;

export const deriveAllowedSportIds = (customer) => {
  if (!customer) return null;
  const info = customer.sportsTypeInfo;
  if (!Array.isArray(info) || info.length === 0) {
    return new Set();
  }
  const set = new Set();
  info.forEach((entry) => {
    if (!entry || entry.isAllowed !== true) return;
    const internalId = sports[entry.name];
    if (typeof internalId === 'number') set.add(internalId);
  });
  return set;
};

export const setAllowedSportIds = (nextSet) => {
  allowedSportIds = nextSet;
};

export const getAllowedSportIds = () => allowedSportIds;

export const isSportAllowed = (sportId) => {
  if (allowedSportIds === null) return true;
  return allowedSportIds.has(Number(sportId));
};

export const isSportNameAllowed = (sportName) => {
  const internalId = sports[sportName];
  if (typeof internalId !== 'number') return false;
  return isSportAllowed(internalId);
};

export const filterAllowedEvents = (events) => {
  if (!Array.isArray(events)) return [];
  if (allowedSportIds === null) return events;
  return events.filter((event) => event && isSportAllowed(event.sport));
};
